// Componentes UI reutilizáveis
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faCheck } from '@fortawesome/free-solid-svg-icons';

// Wrapper para FontAwesome
export const Icon = ({ icon, className }) => (
  <FontAwesomeIcon icon={icon} className={className} />
);

// Link externo com target blank
export const ExternalLink = ({ href, className, children, ...props }) => (
  <a 
    href={href} 
    target="_blank" 
    rel="noopener noreferrer" 
    className={className} 
    {...props}
  >
    {children}
  </a>
);

// 5 estrelas
export const Stars = ({ className = 'text-goshine-orange text-base lg:text-lg' }) => (
  <>
    {[...Array(5)].map((_, i) => (
      <Icon key={i} icon={faStar} className={className} />
    ))}
  </>
);

// Item de checklist
export const CheckItem = ({ children }) => (
  <li className="flex items-center gap-2 text-gray-300 text-sm">
    <div className="w-5 h-5 rounded-full bg-goshine-orange/20 flex items-center justify-center flex-shrink-0">
      <Icon icon={faCheck} className="text-goshine-orange text-[10px]" />
    </div>
    {children}
  </li>
);

// Título de seção
export const SectionTitle = ({ badge, badgeIcon, title, highlight, description }) => (
  <div className="text-center mb-8 sm:mb-12 lg:mb-16">
    {badge && (
      <span className="inline-flex items-center gap-2 text-goshine-orange font-semibold text-sm lg:text-base uppercase tracking-wider mb-3">
        {badgeIcon && <Icon icon={badgeIcon} />}
        {badge}
      </span>
    )}
    <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
      {title} {highlight && <span className="gradient-text">{highlight}</span>}
    </h2>
    {description && (
      <p className="text-sm sm:text-base lg:text-lg text-gray-400 max-w-xl lg:max-w-2xl mx-auto mt-3 lg:mt-4 px-2">
        {description}
      </p>
    )}
  </div>
);
